export const BiCategory = {
  Organization: "Organization",
  CompletionLog: "CompletionLog",
  Employee: "Employee",
  Campaign: "Campaign",
  Conversation: "Conversation",
  Message: "Message",
  Customer: "Customer",
  Support: "Support",
  ConversationGoal: "ConversationGoal",
  Opportunity: "Opportunity",
} as const

export const BiCategoryField = {
  [BiCategory.Campaign]: {
    Active: "Active",
    Created: "Created",
    Live: "Live",
  },
  [BiCategory.Conversation]: {
    Created: "Created",
    Engaged: "Engaged",
    Achieved: "Achieved",
    Kind: "Kind",
    Channel: "Channel",
    AvgMessagePerConversation: "AvgMessagePerConversation",
    AvgTimeToEngage: "AvgTimeToEngage",
    AvgTimeToAchieve: "AvgTimeToAchieve",
    EngagementRate: "EngagementRate",
    AchievementRate: "AchievementRate",
  },
  [BiCategory.Message]: {
    Created: "Created",
    Billable: "Billable",
    Actor: "Actor",
    Kind: "Kind",
    AvgResponseTime: "AvgResponseTime",
    P95ResponseTime: "P95ResponseTime",
  },
  [BiCategory.Customer]: {
    Created: "Created",
  },
  [BiCategory.Support]: {
    Question: "Question",
    Ticket: "Ticket",
    AvgTicketsPerConversation: "AvgTicketsPerConversation",
  },
  [BiCategory.ConversationGoal]: {
    Created: "Created",
    Achieved: "Achieved",
  },
  [BiCategory.CompletionLog]: {
    Tokens: "Tokens",
    Cost: "Cost",
    CostByKind: "CostByKind",
    CostByModel: "CostByModel",
  },
  [BiCategory.Opportunity]: {
    Created: "Created",
    Escalated: "Escalated",
  },
  [BiCategory.Employee]: {
    Invited: "Invited",
    Active: "Active",
  },
  [BiCategory.Organization]: {
    Type: "Type",
    SubscriptionPrice: "SubscriptionPrice",
    SubscriptionCurrentPrice: "SubscriptionCurrentPrice",
  },
} as const
